import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ErrorMessage} from "../sara-input/error-message";
import * as _ from "lodash";

@Component({
    selector: 'sara-selector',
    templateUrl: './sara-selector.component.html',
})
export class SaraSelectorComponent {

    @Input() error:ErrorMessage;
    @Input() name:string;
    @Input() config:any;
    @Input() items:any;
    @Input() validations:any;
    @Input() editable:boolean;

    itemList:any;
    constructor(){
        this.itemList = []
        this.validations = {hasAnySelected:false};
    }

    getKeys(list){
        return !this.items?[]:Object.keys(this.items);
    }

    updateValidation() {
        if(this.error){
            this.error = null;
        }
    }

    toggleItem(oid) {
        this.updateValidation();
        if (!this.items[oid]) {
            this.items[oid] = {checked: true};
        } else {
            this.items[oid].checked = !this.items[oid].checked;
        }
    };

    getItemsList() {
        if(this.items && this.itemList.length == 0){
            for (var i in this.items){
                this.itemList.push({oid: i, name: this.items[i].name.toLowerCase()})
            }
            this.itemList = _.sortBy(this.itemList, 'name');
        }
        return this.itemList;
    }

    checkAll(select) {
        this.updateValidation();
        for (var i in this.items) {
            if (!this.items[i]) {
                this.items[i] = {};
            }
            this.items[i].checked = select;
        }
    };

    responseToJson(){
        return JSON.stringify(this.items);
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-selector/sara-selector.component.ts